<form id="switchUserForm">
  <div class="modal-header">
    <strong class="text-primary bold fs-5 d-inline-block">สลับ User</strong>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>
  <div class="modal-body">
    <div class="mb-4 row">
      <label for="search" class="col-xl-3 ps-xl-4 col-form-label ui-require text-end">ค้นหาจาก</label>
      <div class="col-xl-6">
        <input type="text" id="search" name="search" class="form-control">
      </div>
      <div class="col-xl-2">
        <button type="button" (click)="search()" class="btn btn-primary custom-button mx-1 btn-main confirm-btn">
          <i class="bi bi-search me-2"></i> ค้นหา
        </button>
      </div>
    </div>
    @if (isSearch) {
      @if (userList === undefined || userList.length == 0) {
        <div class="mb-3 row">
          <app-not-found></app-not-found>
        </div>
      } @else {
        @for (user of userList; track user.userName) {
          <hr>
          <div class="mb-3 row">
            <label class="col-xl-2 ps-xl-4 col-form-label text-end">ชื่อผู้ใช้งาน</label>
            <label class="col-xl-2 ps-xl-4 col-form-label text-start">{{ user.userName }}</label>
            <label class="col-xl-2 ps-xl-4 col-form-label text-end">รหัส/ชื่อหน่วยงาน</label>
            <label class="col-xl-4 ps-xl-4 col-form-label text-start">{{ user.orgName }}</label>
            <div class="col-xl-2">
              <button (click)="select(user)" class="btn btn-primary">
                เลือก
              </button>
            </div>
          </div>
          <div class="mb-3 row">
            <label class="col-xl-6 ps-xl-4 col-form-label text-end">อีเมล</label>
            <label class="col-xl-4 ps-xl-4 col-form-label text-start">{{ user.email }}</label>
          </div>
          <div class="mb-3 row">
            <label class="col-xl-2 ps-xl-4 col-form-label text-end">ชื่อ-นามสกุล</label>
            <label class="col-xl-2 ps-xl-4 col-form-label text-start">{{ user.name }}</label>
            <label class="col-xl-2 ps-xl-4 col-form-label text-end">บทบาท</label>
            <label class="col-xl-4 ps-xl-4 col-form-label text-start">{{ user.roleName }}</label>
          </div>
        }
      }
    }
  </div>
</form>
